module.exports = __webpack_public_path__ + "assets/img/banner3.6653c7fe.png";